import React, { useState } from 'react';
import {
  Typography,
  Spinner,
  Button,
  RadioCardGroup
} from '@telus-uds/components-web';
import { Modal } from 'react-responsive-modal';
import PropTypes from 'prop-types';

const defaultCopy = {
  title: 'Select export type',
  allOrdersLabel: 'All Orders',
  allOrdersDescription: 'Download an excel file with all orders of last 3 months',
  filteredOrdersLabel: 'Filtered Orders',
  filteredOrdersDescription: 'Download an excel file with the filtered orders',
  exportButtonLabel: 'Export Orders',
  processingLabel: 'Request is processing.'
};

/**
 * Shared ExportOrdersModal. Optional copy and custom Spinner when loading.
 * @param {boolean} isVisible
 * @param {Function} onClose
 * @param {Function} onExportOrders - (exportType: 'all' | 'filtered') => void
 * @param {boolean} isLoading
 * @param {Object} copy - Optional overrides for title, allOrdersDescription, etc.
 * @param {React.Component} SpinnerComponent - When provided and isLoading, show this instead of form (e.g. full-page spinner)
 */
const ExportOrdersModal = ({
  isVisible = false,
  onClose,
  onExportOrders,
  isLoading = false,
  copy = {},
  SpinnerComponent
}) => {
  const [exportType, setExportType] = useState('all');
  const c = { ...defaultCopy, ...copy };

  const showFullPageSpinner = isLoading && SpinnerComponent;

  const radioItems = [
    {
      id: 'all',
      title: c.allOrdersLabel,
      content: <Typography>{c.allOrdersDescription}</Typography>
    },
    {
      id: 'filtered',
      title: c.filteredOrdersLabel,
      content: <Typography>{c.filteredOrdersDescription}</Typography>
    }
  ];

  return (
    <Modal
      open={isVisible}
      onClose={onClose}
      center
      classNames={{
        overlay: 'customOverlay',
        modal: 'customModal'
      }}
    >
      {showFullPageSpinner ? (
        <SpinnerComponent />
      ) : (
        <>
          <div style={{ width: '90%' }}>
            <Typography heading="h2" variant={{ size: 'h2' }} block>
              {c.title}
            </Typography>
          </div>
          <div style={{ height: 20 }} />
          <div style={{ width: 480 }}>
            <RadioCardGroup
              name="exportOrderType"
              checkedId={exportType}
              onChange={newId => setExportType(newId)}
              items={radioItems}
            />
          </div>
          <div style={{ height: 20 }} />
          <Spinner
            show={isLoading}
            variant={{ size: 'small' }}
            label={c.processingLabel}
            inline
          >
            <Button onClick={() => onExportOrders(exportType)}>
              {c.exportButtonLabel}
            </Button>
          </Spinner>
        </>
      )}
    </Modal>
  );
};

ExportOrdersModal.propTypes = {
  isVisible: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onExportOrders: PropTypes.func.isRequired,
  copy: PropTypes.shape({
    title: PropTypes.string,
    allOrdersLabel: PropTypes.string,
    allOrdersDescription: PropTypes.string,
    filteredOrdersLabel: PropTypes.string,
    filteredOrdersDescription: PropTypes.string,
    exportButtonLabel: PropTypes.string,
    processingLabel: PropTypes.string
  }),
  SpinnerComponent: PropTypes.elementType
};

export default ExportOrdersModal;
